var map = {
	"./facebook.png": 63691,
	"./instagram.png": 45963,
	"./linkedin.png": 42833,
	"./main_logo_light.png": 38741,
	"./spotify.png": 99185,
	"./twiter.png": 25054,
	"./youtube.png": 42804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20951;